let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("cBU7v")).then(() => parcelRequire('bY0t3'));